import { Navigate ,useLocation} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userHasRole } from "../../slices/auth";

//import { history } from '_helpers';

export { PrivateRoute };

function PrivateRoute({ children , role}) {
    const { isLoggedIn } = useSelector((state) => state.auth);
    const location = useLocation();

    const isOk = useSelector(state => userHasRole(state, role));

    //debugger;

    if (!isLoggedIn) {
        // not logged in so redirect to login page with the return url
        return <Navigate to="/login" state={{ from: location.pathname }}/>
    }

    if (role !== undefined && role !== "" && !isOk)
    {
        // does not have the right roll to use this area of the site 
        return <Navigate to="/forbidden" state={{ from: location.pathname }}/>
    }

    // authorized so return child components
    //state={{ from: history.location }} 
    return children;
}